"use strict";

var _classCallCheck = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Infecter = void 0;

var Utils_1 = require("../../../../Utils");

var Infecter =
/*#__PURE__*/
function () {
  function Infecter(container) {
    _classCallCheck(this, Infecter);

    this.container = container;
  }

  _createClass(Infecter, [{
    key: "isEnabled",
    value: function isEnabled() {
      return this.container.options.infection.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact(p1, delta) {
      var _a, _b;

      var infecter1 = p1.infecter;
      infecter1.updateInfection(delta.value);

      if (infecter1.infectionStage === undefined) {
        return;
      }

      var container = this.container;
      var options = container.options;
      var infectionOptions = options.infection;

      if (!infectionOptions.enable || infectionOptions.stages.length < 1) {
        return;
      }

      var infectionStage1 = infectionOptions.stages[infecter1.infectionStage];
      var pxRatio = container.retina.pixelRatio;
      var radius = p1.size.value * 2 + infectionStage1.radius * pxRatio;
      var pos = p1.getPosition();
      var infectedStage1 = (_a = infectionStage1.infectedStage) !== null && _a !== void 0 ? _a : infecter1.infectionStage;
      var query = container.particles.quadTree.query(new Utils_1.Circle(pos.x, pos.y, radius)).filter(function (p) {
        return p.infecter.infectionStage === undefined || p.infecter.infectionStage !== infecter1.infectionStage;
      });
      var infections = infectionStage1.rate;
      var neighbors = query.length;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p2 = _step.value;
          var infecter2 = p2.infecter;

          if (Math.random() < infections / neighbors) {
            if (infecter2.infectionStage === undefined) {
              infecter2.startInfection(infectedStage1);
            } else if (infecter2.infectionStage < infecter1.infectionStage) {
              infecter2.updateInfectionStage(infectedStage1);
            } else if (infecter2.infectionStage > infecter1.infectionStage) {
              var infectionStage2 = infectionOptions.stages[infecter2.infectionStage];
              var infectedStage2 = (_b = infectionStage2 === null || infectionStage2 === void 0 ? void 0 : infectionStage2.infectedStage) !== null && _b !== void 0 ? _b : infecter2.infectionStage;
              infecter1.updateInfectionStage(infectedStage2);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);

  return Infecter;
}();

exports.Infecter = Infecter;